import Vue from 'vue'
import VueRouter from 'vue-router'
import Form from '../views/form/Form.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Form,
    name: 'Form'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
